import { ILoadingTypeMySuffix } from 'src/app/shared/model//loading-type-my-suffix.model';

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface IPackingTypeMySuffix {
    id?: number;
    name?: string;
    activeStatus?: ActiveStatus;
    loadingTypes?: ILoadingTypeMySuffix[];
    ischecked?: boolean;
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    fromEffectiveDate?:string;
}

export class PackingTypeMySuffix implements IPackingTypeMySuffix {
    constructor(
        public id?: number,
        public name?: string,
        public activeStatus?: ActiveStatus,
        public loadingTypes?: ILoadingTypeMySuffix[],
        public ischecked?: boolean,
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public fromEffectiveDate?:string,
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
        this.ischecked = false;
    }
}
